import MathAdv from "./math";
import {TIMER} from "../../utills/timer";
import {TweenTarget} from "./tween-target";
import Easing from "./easing";

export class PathTween {
    public pathFunction: any
    public easing: any
    public closed: any
    public xPoints: any
    public yPoints: any
    public easeFunction: any
    public duration: any
    public followRotation: any
    public lastPoint: any
    public elapsed: any
    public elapsedTick: any
    public target: any
    public path: any
    public running: any
    public targets: any
    private tickupRequest: any;
    private gamePause: boolean;
    private onUpdateFunc: any;
    private onCompleteFunc: any;

    constructor(
        target: any,
        path: any,
        duration: any,
        pathFunction: any,
        easingfunc: any,
        startDelay: any = null,
        closed: any = true,
        followRotation: any = true,
        onUpdate:any=()=>{},
        onComplete:any=()=>{}
    ) {
        this.gamePause = false;
        this.onUpdateFunc = onUpdate;
        this.onCompleteFunc = onComplete;
        var i,
            target,
            pathTween = this,
            instantPath = [];
        //catmullRom
        //bezier
        //linear
        if (typeof pathFunction === "string") {
            // @ts-ignore
            this.pathFunction = MathAdv[pathFunction + "Interpolation"];
        } else if (typeof pathFunction === "function") {
            this.pathFunction = pathFunction;
        }
        if (typeof easingfunc === "string") {
            // @ts-ignore
            this.easing = Easing[easingfunc];
        } else if (typeof easingfunc === "function") {
            this.easing = easingfunc;
        }

        if (this.easing === undefined) {
            console.error("unrecognized easing function");
            // @ts-ignore
            return null;
        }
        this.closed = closed;

        if (this.closed === true) {
            path.push(path[0]);
        }

        this.xPoints = [];
        this.yPoints = [];

        for (i = 0; i < path.length; i += 1) {
            this.xPoints.push(path[i].x);
            this.yPoints.push(path[i].y);
        }

        this.easeFunction = this.ease;
        this.duration = duration;
        this.followRotation = followRotation;
        this.lastPoint = path[0];

        this.elapsed = 0;
        this.elapsedTick = Date.now();

        this.target = new TweenTarget();
        this.target.setProperties(target);
        this.path = path;

        this.running = false;

        // this.addEventListener("update", this.onUpdate);

        if (startDelay === null || startDelay === undefined) {
            this.start();
        } else if (startDelay === -1) {
            this.target.object = {x: path[0].x, y: path[0].y};
            this.elapsed = -1;
            this.running = true;
            for (i = 0; i < this.duration; i += 1) {
                this.elapsed += 1;
                this.onUpdate({elapsed: 0});
                if (this.running === true) {
                    instantPath.push({
                        x: this.target.object.x,
                        y: this.target.object.y
                    });
                }
            }
            // @ts-ignore
            return instantPath;
        } else {
            let timer = TIMER.TimerManager.createTimer(startDelay)
            timer.on('end', () => {
                pathTween.start();
            })
            timer.start();
            // var timer = new Utils.Timer(startDelay, 1);
            // timer.addEventListener("complete", function(e) {
            //     pathTween.start();
            // });
            // timer.start();
        }
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === 'visible') {
                this.onGameResume();
            } else {
                this.onGamePause()
            }
        });
        this.tick();
    }
    onGameResume() {
        const now = Date.now();

        this.elapsedTick = now;
        this.gamePause = false;
        this.running = true

    }

    onGamePause() {

        const now = Date.now();

        this.elapsedTick = now;
        this.gamePause = true;
        this.running = false

    }
    tick = () => {
        this.tickupRequest = requestAnimationFrame(this.tick);
        const now = Date.now();
        if (this) {
            // this.onUpdate((now - this.elapsed) * 0.001);
            this.onUpdate({elapsed: (now - this.elapsedTick) * 0.001});
            // this.onUpdate({ elapsed: (now) * 0.001 });
        }
        this.elapsedTick = now;
    }

    /**
     * Adds the update event handler
     * starts the tween
     */
    start() {
        this.running = true;

        this.elapsed = 0;

        //Prime.engine.addEventHandler("update", this);
    }

    /**
     * Sets the target to final positions and remove the update handler
     */
    stop() {
        if (this.running === true) {
            this.running = false;
            // Prime.engine.removeEventHandler("update", this);
            cancelAnimationFrame(this.tickupRequest);
            this.elapsed = this.duration;
            this.ease();
            this.dispose();
            this.onCompleteFunc && this.onCompleteFunc(this);
            // let e :any = new Event("complete");
            // e.target = this;
            // this.call(e);
        }
    }

    call(event: any) {
        // var i = 0;
        // if (!this.listeners) {
        //     return;
        // }
        //
        // for (i = 0; i < this.listeners.length; i = i + 1) {
        //     var listener = this.listeners[i];
        //
        //     if (listener.type === event.type) {
        //         if (listener.func !== undefined) {
        //             listener.func.call(this, event);
        //             if (this.listeners === null) {
        //                 break;
        //             }
        //         } else {
        //             // cant import Utils
        //             // Logger.warn(
        //             //     "listener function not found for event type: " +
        //             //     event.type +
        //             //     " in handler: " +
        //             //     this
        //             // );
        //         }
        //     }
        // }
    }

    /**
     *
     * @param {Object} event
     */
    onUpdate(event: any) {
        if (this.running === true) {
            this.onUpdateFunc && this.onUpdateFunc(this);
            this.elapsed += event.elapsed;
            if (this.elapsed < this.duration) {
                this.ease();
            } else {
                if (this.closed === true) {
                    this.elapsed = 0;
                    this.ease();
                } else {
                    this.stop();
                }
            }
        }
    }

    /**
     * Uses the easing function to get a normalized value to pas to the path function
     *
     */
    ease() {

        var time = this.easing(this.elapsed, 0, 1, this.duration);
        this.target.object.x = this.pathFunction.call(MathAdv, this.xPoints, time);
        this.target.object.y = this.pathFunction.call(MathAdv, this.yPoints, time);
        if (this.followRotation === true) {
            this.target.object.rotation = MathAdv.angleBetweenPoints(
                this.target.object,
                this.lastPoint
            );
            this.lastPoint = {x: this.target.object.x, y: this.target.object.y};
        }
    }

    /**
     * Removes the onUpdate handler and listener, and disposes of the targets
     * @param {Object} event
     */
    dispose(event?: any) {
        if (this.running === true) {
            // Prime.engine.removeEventHandler("update", this);
            cancelAnimationFrame(this.tickupRequest);
            this.running = false;
        }

        this.target = null;
        cancelAnimationFrame(this.tickupRequest);
        //this.removeEventListener("update", this.onUpdate);

        for (var target in this.targets) {
            this.targets[target].dispose();
        }
        this.targets = null;
    }
}